<template>
  <div>
        <!-- Button trigger modal -->
        <div v-if="user.token != ''" class="mb-5" id="mainHeader3">
            <header>
              <div class="sticky-wrapper" style="height: 10px;">
                <div :class="['sticky-nav', { stuck: isStuck }]">
                  <div class="header-content">
                    <div id="logo">
                      <div class="float-left" @click="change_view('lobby')" style="cursor:pointer">
                        <img  @click="render_home" v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo" :width="skin.header_desktop.logo_width" alt="" style="max-width: 170px; max-height: 45px;">
                      </div>
                    </div>
                    <div style="margin-left: 100px;">
                        <span :style="(this.message_recived?'color:red;':'')" @click="openSupportModalJivo()">
                            <i class="fa-regular fa-comment-dots"></i>
                        </span>
                    </div>
                    <a id="mobile-nav" class="menu-nav" href="#" @click="toggleMenu">
                      <i :class="menuOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
                    </a>
                  </div>
                </div>
                <nav id="navigation-mobile" :class="{ open: menuOpen }">
                    <ul id="menu-nav-mobile" class="list-group list-group-flush">
                      <li class="list-group-item bg-transparent align-content-center" style="color:darkgray;">Usuario: 
                        <span class="color-text" @click="goTo()" style="cursor: pointer;">
                          {{ user.user_data.data ? user.user_data.data.user_name : '' }}&nbsp;
                          <span class="color-text font-icon-cogs"><i class="fa fa-cogs" aria-hidden="true"></i></span>
                        </span>
                      </li>
                      <li class="list-group-item bg-transparent align-content-center" style="color:darkgray;" v-if="skin.header_desktop.balance">Fichas: 
                        <span class="color-text" id="Saldo">
                          <strong><b>{{ user.user_data.data ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: skin.qBet_config.decimalsQty, maximumFractionDigits: skin.qBet_config.decimalsQty }).format(balance.saldo) : 0 }}</b></strong>
                        </span>
                      </li>
                      <li class="list-group-item bg-transparent align-content-center" style="color:darkgray;">Puesto: <span class="color-text">Sin Ranking</span></li>
                      <li class="list-group-item bg-transparent align-content-center" style="color:darkgray;"><a class="external" href="#" v-if="homeButton" @click="render_home">HOME</a></li>
                      <li class="list-group-item bg-transparent align-content-center" style="color:darkgray;"><a class="external" href="#" v-if="skin.logout" @click="logout">SALIR</a></li>
                    </ul>
                  </nav>
              </div>
            </header>
          </div>
            <myAccountZeus
                    v-bind:skin="skin"
                    v-bind:language="language"
                    v-bind:translation="translation"
                />
            <login3 v-if="user.token == ''" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword
                v-bind:skin="skin"
                v-bind:language="language"
                v-bind:translation="translation"
            />
            <misDatos
                v-if="mis_datos"
                v-bind:skin="skin"
                v-bind:language="language"
                v-bind:translation="translation"
            />
            <register
                v-bind:skin="skin"
                v-bind:language="language"
                v-bind:translation="translation"
            />
    </div>
</template>

<script>
import myAccountZeus from "./my_account.vue";
import login3 from "./login.vue";
import register from './register.vue';
import router from "../../../router";
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";
import misDatos from "./mis_datos.vue";
import axios from "axios";
export default {
    name:"header_mobil2",
    props:["skin","translation","language"],
    components:{
        myAccountZeus,
        login3,
        register,
        languageSelector,
        changePassword,
        misDatos},
    data(){
        return {
            userDataLoaded:false,
            showBalance:false,
            supportTickets:[],
            menuOpen: false,
            isStuck: false,
            balance:{
                saldo:0,
                conversion:0,
                view:"SALDO",
                switch:1
            }
        }
    },
    computed:{
        user(){
            let data = this.$store.getters['getUserData'];
            if(data.user_data.data){
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
         },
         jivo_modal_flag(){
            return this.$store.getters["getModalFlag"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        mis_datos() {
            return this.$store.getters["getMisdatos"]
        },
        message_recived(){
            return this.$store.getters["getMessage"]
        },
        actualRoute(){
            return this.$store.getters["getActualRoute"]
        },
        homeButton() {
            return this.$store.getters["getHomeButton"]
        },
        currency(){
            return this.$store.getters['getCurrency'];
         }
    },
    methods:{
        render_home() {
             if (this.actualRoute=='Home') {
                const iframeContainer = document.querySelector('.holds-the-iframe');
                if (iframeContainer) {
                    // Enviar mensaje al iframe para que se recargue
                    const iframe = iframeContainer.querySelector('iframe');
                    if (iframe) {
                        iframe.contentWindow.postMessage({ action: 'reloadIframe' }, '*');
                        this.$store.dispatch("setHomeButton", false);
                        this.$store.dispatch("setMisdatos", false);
                        this.menuOpen = false;
                    } else {
                            // console.error('No se encontró un iframe dentro del contenedor con la clase "holds-the-iframe".');
                    }
                } else {
                    // console.error('No se encontró el contenedor con la clase "holds-the-iframe".');
                    this.$store.dispatch("setMisdatos", false);
                    this.$store.dispatch("setHomeButton", false);
                    this.menuOpen = false;
                }                
            } else {
                router.push({name:"Home"}).catch(() => {})
                this.$store.dispatch("setHomeButton", false);
                this.$store.dispatch("setMisdatos", false);
                this.menuOpen = false;
            }
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction(){
            if(!this.showBalance){
                this.$store.dispatch('getProfile',{
                    token:this.user.token,
                    site_id:this.user.site_id,
                    site:this.user.site,
                    prefix:this.user.prefix,
                    playerId:this.user.user_data?.data?.user_id,
                    source:"main"
                });
                this.showBalance = true
            }
            else{
                this.showBalance = false
            }
        },
        countDays(init){
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        terms(){
            let url = "";
            let lang = this.$props.language=='es'?'spa':(this.$props.language=='en'?'eng':(this.$props.language=='pt'?'pt-br':'spa'));
            if(this.user.prefix=="external"){
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+this.user.site.toUpperCase()+"&link="+this.user.site;
            }
            else{
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1]+'.'+domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+domain_name1+"&link="+domain_name2;
            }
            
            window.open(url, '_blank').focus();
        },
        getMovements(){
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos(){
            this.$root.$emit('getIngresosHistory');
        },
        show_user_recharge(){
            this.$root.$emit("show_user_recharge");
        },
        openSupportModalJivo() {
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag",false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag",true);
                this.$store.dispatch("setMessage", false);
            }
        },
        balanceParsed(val,fiat){
            let tasa = 1;
            if(this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false){
                tasa = this.currency.rate;
            }
            return (fiat!='BETC'?(fiat=='USDT'?val*tasa:val*tasa*this.user.user_data.data.tasa):val).toFixed(2);
        },
        login(){
            document.getElementById('login_btn').click();
        },
        logout(){
            this.toggleMenu()
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
            this.$store.dispatch("setHomeButton", false);
            this.$store.dispatch("setMisdatos", false);
            // this.menuOpen = !this.menuOpen;
        },
        register(){
            document.getElementById('register_btn').click();
        },
        change_view(view){
            this.$store.dispatch('setView',view);
        },
        translate(text) {
            if(text){
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else{
                    var new_text_serched = text.replace(/ /g, "_");
                if (this.$props.translation[new_text_serched]) {
                    return this.$props.translation[new_text_serched][this.$props.language];
                }
                }
                return text;
            }
        },
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        goTo() {
            this.$store.dispatch("setMisdatos", true);
            this.$store.dispatch("setHomeButton", true);
            this.menuOpen = !this.menuOpen;
        },
        handleScroll() {
            this.isStuck = window.scrollY > 0;
        }
    },
    watch:{
        showBalance(newVal,oldVal){
            if(newVal){
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
     },
     mounted(){
        window.addEventListener('scroll', this.handleScroll);
        // this.$store.dispatch("setHeaderHeight",document.getElementById("mainHeader").offsetHeight+5);
     },
     created(){
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function(){
            try {
                if(self.user.user_data.data){
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId:self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        },balanceRequestTime);
     }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');

header {
  width: 100%;
  z-index: 99;
  color: #7f8289;
  font-weight: 300;
  font-size: 16px;
  font-family: 'Titillium Web', sans-serif;
  line-height: 28px;
}

header .sticky-nav {
  position: relative;
  width: 100%;
  height: 60px;
  z-index: 1001;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

header .sticky-nav.stuck {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
}

#mobile-nav {
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
  height: 20px;
}

#navigation-mobile {
  display: none;
  text-align: center;
  width: 100%;
  background: #26292e;
  border-bottom: 1px solid #8c9097;
  position: relative;
  float: left;
  z-index: 9999;
}

#navigation-mobile.open {
  display: block;
}

#menu-nav-mobile {
  margin: 0;
  padding: 0;
  list-style: none;
}

#menu-nav-mobile li {
  display: block;
  padding: 0 0;
}

#menu-nav-mobile li .color-text {
  color: #00b7ff;
}

a {
  color: #00b7ff;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.1s linear;
}

.menu-nav {
  cursor: pointer;
}

.menu-nav.open {
  background-position: 0 -16px;
  transform: rotate(-180deg);
  transition: transform 250ms ease-out;
}
</style>./login.vue./my_account.vue